import { render, staticRenderFns } from "./TwismWallet.vue?vue&type=template&id=2098b928&scoped=true&"
import script from "./TwismWallet.vue?vue&type=script&lang=ts&"
export * from "./TwismWallet.vue?vue&type=script&lang=ts&"
import style0 from "./TwismWallet.vue?vue&type=style&index=0&id=2098b928&lang=sass&scoped=true&"
import style1 from "./TwismWallet.vue?vue&type=style&index=1&id=2098b928&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2098b928",
  null
  
)

export default component.exports